import React, { useState, useRef, useEffect } from "react";
import "../payment/payment.css";
import "./addCardForm.css";
import axios from "axios";
import { useDispatch } from "react-redux";
import { actions } from "../redux/main-reducer";

const AddCardForm = ({ setCommonErrorMessage, onCancel, onCardSaved }) => {
  const [cardNumber, setCardNumber] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [showExpiryFields, setShowExpiryFields] = useState(false);
  const [showOtpField, setShowOtpField] = useState(false);
  const [otp, setOtp] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isOtpSubmitting, setIsOtpSubmitting] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);
  const [canResend, setCanResend] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorMessageExpireDate, setErrorMessageExpireDate] = useState("");
  const [key, setKey] = useState("");
  
  const monthRef = useRef(null);
  const yearRef = useRef(null);
  const otpRef = useRef(null);

  const API_ROOT = process.env.REACT_APP_API_ROOT;

  const dispatch = useDispatch();

  // Таймер для повторной отправки OTP
  useEffect(() => {
    let interval;
    if (showOtpField && resendTimer > 0) {
      interval = setInterval(() => {
        setResendTimer(prev => {
          if (prev <= 1) {
            setCanResend(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [showOtpField, resendTimer]);

  // Запуск таймера только при первом показе OTP поля
  useEffect(() => {
    if (showOtpField && resendTimer === 0 && !canResend) {
      setResendTimer(60);
      setCanResend(false);
    }
  }, [showOtpField, canResend]);

  const handleCardNumberChange = (e) => {
    const rawValue = e.target.value.replace(/\D/g, "");
    setCardNumber(rawValue.slice(0, 16));
    if (rawValue?.length === 16 && !showExpiryFields) {
      setShowExpiryFields(true);
      setTimeout(() => monthRef.current?.focus(), 0);
      return;
    }
    if (rawValue?.length === 16 && showExpiryFields) {
      monthRef.current?.focus();
    }
  };

  const handleMonthChange = (e) => {
    let value = e.target.value.replace(/\D/g, "");
    if (value.length > 2) value = value.slice(0, 2);
    
    const monthNum = parseInt(value, 10);
    if (value.length === 1 && monthNum > 1) {
      value = "0" + value;
      setMonth(value);
      yearRef.current?.focus();
    } else if (value.length === 2) {
      if (monthNum >= 1 && monthNum <= 12) {
        setMonth(value);
        yearRef.current?.focus();
      } else {
        return; // не устанавливаем невалидное значение
      }
    } else {
      setMonth(value);
    }
  };

  const handleYearChange = (e) => {
    let value = e.target.value.replace(/\D/g, "");
    if (value.length > 2) value = value.slice(0, 2);
    setYear(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const key = new URLSearchParams(window.location.search).get("key");

      if (!cardNumber || cardNumber?.length < 16) {
        setErrorMessage("Введите номер карты");
        return;
      }

      if (!month || !year) {
        setErrorMessageExpireDate("Введите срок карты");
        return;
      }

      const formattedExpiryDate = `${month}${year}`; // например, "0426"

      const data = {
        card_expiry: formattedExpiryDate,
        card_number: cardNumber,
        invoice_key: key,
      };

      console.log(data)

      const response = await axios.post(
        `${API_ROOT}/api/v1/ecomm/card/create`,
        data
      );

      if (response.data && response.data.status === "Success") {
        setKey(response?.data?.data?.key);
        setShowOtpField(true);
      } else {
        throw new Error(
          response?.data?.error_note || "Не удалось сохранить карту"
        );
      }
    } catch (error) {
      console.error("Error during payment request:", error);
      setCommonErrorMessage(error?.response?.data?.error_note || "Произошла ошибка. Пожалуйста, попробуйте позже");
    } finally {
      setIsSubmitting(false);
    }
      // Здесь будет логика отправки данных на сервер и получения OTP
      // onCardSave({
      //   number: cardNumber,
      //   month: month,
      //   year: year,
      //   type: cardType
      // });
  };

  const handleOtpChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 6) {
      setOtp(value);
    }
  };

  const handleResendOtp = async (e) => {
    e.preventDefault();
    setIsOtpSubmitting(true);

    try {

      const data = {
        key: key,
      };

      console.log(data)

      const response = await axios.post(
        `${API_ROOT}/api/v1/ecomm/card/sms/resend`,
        data
      );

      if (response.data && response.data.status === "Success") {
        setResendTimer(60);
        setCanResend(false);
      } else {
        throw new Error(
          response?.data?.error_note || "Не удалось сохранить карту"
        );
      }
    } catch (error) {
      console.error("Error during payment request:", error);
      setCommonErrorMessage(error?.response?.data?.error_note || "Произошла ошибка. Пожалуйста, попробуйте позже");
    } finally {
      setIsOtpSubmitting(false);
    }
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  const handleOtpSave = async (e) => {
      
    // const cardType = getCardType(cardNumber);

    e.preventDefault();
    setIsOtpSubmitting(true);

    try {

      const invoiceKey = new URLSearchParams(window.location.search).get("key");

      const data = {
        confirm_code: otp,
        invoice_key: invoiceKey,
        key: key,
      };

      console.log(data)

      const response = await axios.post(
        `${API_ROOT}/api/v1/ecomm/card/verify`,
        data
      );

      //инвалидация данных
      dispatch(actions.setInvaliidateData(true));
      // Показываем snackbar об успешном сохранении
      onCardSaved();
      // Сбрасываем форму
      setShowOtpField(false);
      setOtp("");
      setCardNumber("");
      setMonth("");
      setYear("");
      setKey("");
      setShowExpiryFields(false);
  } catch (error) {
      console.error("Error during payment request:", error);
      setCommonErrorMessage(error?.response?.data?.error_note || "Произошла ошибка. Пожалуйста, попробуйте позже");
    } finally {
      setIsOtpSubmitting(false);
    }
  };

  const isFormValid = cardNumber.length === 16 && month.length === 2 && year.length === 2 && 
                    parseInt(month, 10) >= 1 && parseInt(month, 10) <= 12 &&
                    (() => {
                      const parsedYear = parseInt(year, 10);
                      const currentYearFull = new Date().getFullYear();
                      const currentYear = currentYearFull % 100;
                      return !isNaN(parsedYear) && parsedYear >= currentYear && parsedYear <= currentYear + 20;
                    })();

  const isOtpValid = otp.length === 6;

  return (
    <div className="add-card-form">
      <form
        className="add-card-form__fields"
        onSubmit={handleSubmit}
      >
        <div className="add-card-form__field">
          <input
            type="tel"
            inputMode="numeric"
            value={cardNumber.match(/.{1,4}/g)?.join(" ") || ""}
            onChange={handleCardNumberChange}
            placeholder="Номер карты"
            maxLength="19"
            className="input-field-card"
            disabled={showOtpField}
          />
          {errorMessage && (
            <div className="error-message">{errorMessage}</div>
          )}
        </div>
        
        {showExpiryFields && (
          <div className="form-group">
            <div className="add-card-form__expiry">
              <div className="add-card-form__field">
                <input
                  type="tel"
                  inputMode="numeric"
                  value={month}
                  onChange={handleMonthChange}
                  placeholder="ММ"
                  maxLength={2}
                  ref={monthRef}
                  className="input-field"
                  disabled={showOtpField}
                />
              </div>
              <div className="add-card-form__separator">/</div>
              <div className="add-card-form__field">
                <input
                  type="tel"
                  inputMode="numeric"
                  value={year}
                  onChange={handleYearChange}
                  placeholder="ГГ"
                  maxLength={2}
                  ref={yearRef}
                  className="input-field"
                  disabled={showOtpField}
                />
              </div>
            </div>
            {errorMessageExpireDate && (
              <div className="error-message">
                {errorMessageExpireDate}
              </div>
            )}
          </div>
        )}

        {!showOtpField && (
           <div className="add-card-form__buttons">
            <button
              disabled={!isFormValid || isSubmitting}
              className={`add-card-form__button add-card-form__button--save ${
                isFormValid ? 'add-card-form__button--enabled' : ''
              }`}
            >
              Сохранить
            </button>
            <button
              onClick={onCancel}
              className="add-card-form__button add-card-form__button--cancel"
            >
              Отмена
            </button>
        </div>
        )}
      </form>
      {showOtpField && (
        <div className="add-card-form-otp">
            <div className="add-card-form__field">
              <input
                type="tel"
                inputMode="numeric"
                value={otp}
                onChange={handleOtpChange}
                placeholder="OTP код"
                maxLength={6}
                ref={otpRef}
                className="input-field"
                disabled={resendTimer === 0}
              />
            </div>
            <div className="add-card-form__timer">
              {resendTimer > 0 ? (
                <span>Отправить код повторно через {formatTime(resendTimer)}</span>
              ) : (
                <button 
                  onClick={handleResendOtp}
                  disabled={!canResend}
                  className="add-card-form__resend-button"
                >
                  Отправить код повторно
                </button>
              )}
            </div>
        </div>
      )}
        {showOtpField && (
          <div className="add-card-form__buttons">
            <button
              onClick={handleOtpSave}
              disabled={!isOtpValid || resendTimer === 0}
              className={`add-card-form__button add-card-form__button--save ${
                isOtpValid && resendTimer > 0 ? 'add-card-form__button--enabled' : ''
              }`}
            >
              Отправить код
            </button>
            <button
              onClick={onCancel}
              className="add-card-form__button add-card-form__button--cancel"
            >
              Отмена
            </button>
        </div>
        )}
    </div>
  );
};

export default AddCardForm;
